module.exports = __webpack_public_path__ + "img/unionCode.76d45003.png";